import { Component, OnInit } from '@angular/core';
import { NotifyService } from '../../services/notify.service';
import { timestampFormat } from '../../../../app/config/moment';
import { AlertsService } from '../../services/alerts.service'; 
import { MatDialog } from '@angular/material/dialog'; 
import { CloseAlertComponent } from './close-alert/close-alert.component';
import { HomeService } from '../../services/home.service';
import { CabinetService } from '../../services/cabinet.service';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { filterRecentNotifications } from '../../../config/moment';

@Component({
  selector: 'app-alerts-notify',
  templateUrl: './alerts-notify.component.html',
  styleUrls: ['./alerts-notify.component.scss', '../../../app.component.scss']
})

export class AlertsNotifyComponent implements OnInit {

  public cabinets: any;
  public filterRecentNotifications = filterRecentNotifications;
  selectedAlert: any;
  public timestampFormat = timestampFormat;
  route: any;
  public closedAlertIds: number[] = [];
  public storeId = "";
  public notify: any = [];
  public alerts: any = [];
  public closeAlerts: any = [];
  cabinetId: any;

  constructor(
    public notifyService: NotifyService,
    public cabinetService: CabinetService,
    public dialog: MatDialog,
    public alertsService: AlertsService,
    public homeService: HomeService,
    private location: Location,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.getnotify();
    this.getalerts();
    this.retrieveClosedAlertIds();
  }

  getnotify() {
    this.notifyService.getnotify().subscribe((res) => {
      if (res.data) {
        this.notify = this.filterRecentNotifications(res.data.data);
      }
    });
  }

  

  getalerts(): void {
    this.alertsService.getalerts().subscribe((res) => {
      if (res.data) {
        const closedAlertIds = JSON.parse(localStorage.getItem('closedAlertIds') || '[]');
        this.alerts = res.data.data.filter((alert: any) => !this.closedAlertIds.includes(alert.id));
      }
    });
  }

  retrieveClosedAlertIds(): void {
    const closedAlertIdsStr = localStorage.getItem('closedAlertIds');
    if (closedAlertIdsStr) {
      this.closedAlertIds = JSON.parse(closedAlertIdsStr);
    }
  }

  // filterRecentNotifications(notifications: any[]): any[] {
  //   const now = moment();
  //   return notifications.filter(notification => {
  //     const notificationTime = moment(notification.updated_at);
  //     return now.diff(notificationTime, 'hours') < 24;
  //   });
  // }
   
  openDialog(alert: any): void {
    const dialogRef = this.dialog.open(CloseAlertComponent, {
      data: {
        cabinet_name: alert.cabinet_name,
        product_name: alert.product_name,
        status: alert.status,
        count: alert.count,
        id: alert.id
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'confirm') {
        this.closeAlert(alert);
      }
    });
  }

  closeAlert(alert: any): void {
    this.homeService.closeAlert(alert.id).subscribe((res) => {
      if (res.success) {
        const index = this.alerts.indexOf(alert);
        if (index !== -1) {
          this.alerts.splice(index, 1);
          this.closedAlertIds.push(alert.id);
          localStorage.setItem('closedAlertIds', JSON.stringify(this.closedAlertIds));
        }
      }
    });
  }

  filterClosedAlerts(): void {
    const closedAlertIds = JSON.parse(localStorage.getItem('closedAlertIds') || '[]');
    this.alerts = this.alerts.filter(alert => !closedAlertIds.includes(alert.id));
  }

  navigateToCabinet(cabinetId: number) {
    this.router.navigate(['/home/stocks/cabinets', cabinetId]);
  }

  navigateToProduct(cabinet_id: number){
    this.router.navigate(['/home/stocks/stores/:id/implants/:type', cabinet_id])
  }
  navigateToNotifyList(){
    this.router.navigate(['/home/notify/list']);
  }

  navigateToAlertList(){
    this.router.navigate(['/home/notify/alert']);
  }

}
